export default {
  name: 'PetRegister',
  component: () => import('../view/PetRegister.vue')
}
